// The Leaflet map tooltip in the kit's dress. Leaflet draws, places and pans it with the map; this
// only styles it, as the HoverCard's twin: the control step, the overlay corner, the overlay
// shadow, a fade in. Put `className={MAP_TIP}` on react-leaflet's <Tooltip> and render
// <MapTipStyle /> once on the page. docs/operations/design-standard.md, "Controls".
//
// Two classes deep on purpose: that outranks Leaflet's own `.leaflet-tooltip` rules with no
// !important. Leaflet positions the tip with an inline transform, so the entrance animates
// opacity only; a transform keyframe would fight it.

import React from 'react';
import { EASE, MS } from './motion';

export const MAP_TIP = 'ui-map-tip';

const CSS = `
.leaflet-tooltip.${MAP_TIP} {
  background: var(--surface-container-highest);
  color: var(--on-surface);
  border: 0;
  border-radius: 8px; /* rounded-overlay; the CSS string cannot read the Tailwind token */
  padding: 6px 10px;
  font-size: 12px;
  line-height: 16px;
  box-shadow: var(--np-overlay-shadow);
  animation: ${MAP_TIP}-in ${MS.standard}ms ${EASE.emphasized} both;
}
.leaflet-tooltip-top.${MAP_TIP}::before { border-top-color: var(--surface-container-highest); }
.leaflet-tooltip-bottom.${MAP_TIP}::before { border-bottom-color: var(--surface-container-highest); }
.leaflet-tooltip-left.${MAP_TIP}::before { border-left-color: var(--surface-container-highest); }
.leaflet-tooltip-right.${MAP_TIP}::before { border-right-color: var(--surface-container-highest); }
@keyframes ${MAP_TIP}-in { from { opacity: 0; } to { opacity: 1; } }
@media (prefers-reduced-motion: reduce) { .leaflet-tooltip.${MAP_TIP} { animation: none; } }
`;

export const MapTipStyle: React.FC = () => <style>{CSS}</style>;

export default MapTipStyle;
